import { firestoreAction } from 'vuexfire'
import {db} from '@/firebase'

const subservices_avaiact = db.collection('subservices_avaiact')
const subservices_avaitem = db.collection('subservices_avaitem')
const subservices_avairoom = db.collection('subservices_avairoom')
const subservices_drink = db.collection('subservices_drink')
const subservices_extrafac = db.collection('subservices_extrafac')
const subservices_gymfac = db.collection('subservices_gymfac')
const subservices_health = db.collection('subservices_health')
const subservices_inhouse = db.collection('subservices_inhouse')
const subservices_maxcap = db.collection('subservices_maxcap')
const subservices_restmeal = db.collection('subservices_restmeal')
const subservices_payplan = db.collection('subservices_payplan')
const subservices_rewprice = db.collection('subservices_rewprice')
const subservices_roomview = db.collection('subservices_roomview')
const subservices_special = db.collection('subservices_special')
const subservices_starshows = db.collection('subservices_starshows')
const subservices_training = db.collection('subservices_training')
const subservices_transtrips = db.collection('subservices_transtrips')

const state = {
  services: [],
  subservices_avaiact: [],
  subservices_avaitem: [],
	subservices_avairoom: [],
	subservices_drink: [],
	subservices_extrafac: [],
	subservices_gymfac: [],
	subservices_health: [],
	subservices_inhouse: [],
	subservices_maxcap: [],
	subservices_restmeal: [],
	subservices_payplan: [],
	subservices_rewprice: [],
	subservices_roomview: [],
	subservices_special: [],
	subservices_starshows: [],
	subservices_training: [],
	subservices_transtrips: []
}

const getters = {
  serv: state => (
    state.services[0] ? state.services[0] : {}
  )
}

const actions = {
  initServico: firestoreAction(({ bindFirestoreRef }, slug) => {
    bindFirestoreRef('services', db.collection('services').where('slug', '==', slug))
  }),

  initAvaiActSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_avaiact', subservices_avaiact.where('s_id', '==', s_id))
  }),
  initAvaItemSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_avaitem', subservices_avaitem.where('s_id', '==', s_id))
  }),
  initAvaiRoomSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_avairoom', subservices_avairoom.where('s_id', '==', s_id))
  }),
  initDrinkSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_drink', subservices_drink.where('s_id', '==', s_id))
  }),
  initExtrafacSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_extrafac', subservices_extrafac.where('s_id', '==', s_id))
  }),
  initGymFacSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_gymfac', subservices_gymfac.where('s_id', '==', s_id))
  }),
  initHealthSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_health', subservices_health.where('s_id', '==', s_id))
  }),
  initInhouseSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_inhouse', subservices_inhouse.where('s_id', '==', s_id))
  }),
  initMaxCapSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_maxcap', subservices_maxcap.where('s_id', '==', s_id))
  }),
  initRestMealServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_restmeal', subservices_restmeal.where('s_id', '==', s_id))
  }),
  initPayPlanSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_payplan', subservices_payplan.where('s_id', '==', s_id))
  }),
  initRewPriceSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_rewprice', subservices_rewprice.where('s_id', '==', s_id))
  }),
  initRoomViewSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_roomview', subservices_roomview.where('s_id', '==', s_id))
  }),
  initSpecialSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_special', subservices_special.where('s_id', '==', s_id))
  }),
  initStarShowsSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_starshows', subservices_starshows.where('s_id', '==', s_id))
  }),
  initTrainingSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_training', subservices_training.where('s_id', '==', s_id))
  }),
  initTransTripSubServices: firestoreAction(({ bindFirestoreRef }, s_id) => {
    bindFirestoreRef('subservices_transtrips', subservices_transtrips.where('s_id', '==', s_id))
  }),

}

export default {
  namespaced: true,
  state,
  actions,
  getters
}